import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import AdminDetailsForm from '../AdminsAdminDetailsForm';
import ActionButton from '~components/atoms/ActionButton';

import { TEditAdminDetailsReduxParams } from '~types/feat/admin';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_adminsAdminDetails.module.scss';

const AdminsAdminDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.admin.modals.adminDetailsModalIsOpen);
    const isEditing = useAppSelector(state => state.admin.modals.adminDetailsModalIsEditing);
    const editAdminDetailsIsLoading = useAppSelector(state => state.admin.loadings.editAdminDetails);
    const editAdminDetailsError = useAppSelector(state => state.admin.errors.editAdminDetails);
    const adminDetails = useAppSelector(state => state.admin.adminDetails);
    const userAccess = useAppSelector(state => state.auth.userDetails.access);

    const hasEditAccess = userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.RBAC);

    const setIsEditing = (isEditMode: boolean) => dispatch(combinedActions.adminSetAdminDetailsModalIsEditing(isEditMode));

    const handleModalOnClose = () => {
        setIsEditing(false);
        dispatch(combinedActions.adminResetEditAdminDetailsState());
        dispatch(combinedActions.adminSetAdminDetailsModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditAdminDetailsReduxParams) => {
        if (isEditing) {
            dispatch(combinedActions.adminEditAdminDetailsAttempt(data));
        }
    };

    return (
        <Modal
            title='Admin Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >

            <div className={Styles.subcontainer}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {hasEditAccess
                        && (
                            <ActionButton
                                label={isEditing ? 'Disable editing' : 'Enable editing'}
                                onClick={() => setIsEditing(!isEditing)}
                            />
                        )
                    }
                </div>

                <AdminDetailsForm
                    submitButtonLabel='Update Admin'
                    actionButtonIsLoading={editAdminDetailsIsLoading}
                    actionButtonClassName={Styles['form-action-button-disabled']}
                    actionButtonIsDisabled={!isEditing}
                    onSubmit={handleOnSubmit}
                    isEditing={isEditing}
                    inputIsDisabled={!isEditing}
                    error={editAdminDetailsError}
                    initialAdminDetails={adminDetails}
                />
            </div>
        </Modal>
    );
};

export default AdminsAdminDetailsModal;
